// ======MLVeda Currency Switcher======
const currencyInterval = setInterval(appendCurrencyToHeader, 1000);
function appendCurrencyToHeader() {
  const currency = document.querySelector(".pick_currency");
  const ulMenu = document.querySelector(
    "ul.header__secondary-navigation.menu.right"
  );
  const newLi = document.createElement("li");
  if (currency != null) {
    if (window.screen.width >= 769) {
      newLi.appendChild(currency);
      ulMenu.insertBefore(newLi, ulMenu.firstChild);
      clearInterval(currencyInterval);
    } else {
      const mobileHeader = document.querySelector("#header")
      mobileHeader.appendChild(currency)
      clearInterval(currencyInterval);
    }
  }
}
